import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Login from '../../components/Login';

const Layout = ({ children }) => {
  const [loggedInEmployee, setLoggedInEmployee] = useState(null);

  useEffect(() => {
    // Sprawdź czy użytkownik jest zalogowany przy ładowaniu strony
    const savedEmployee = localStorage.getItem('loggedInEmployee');
    if (savedEmployee) {
      setLoggedInEmployee(savedEmployee);
    }
  }, []);

  const handleLogin = (employeeNumber) => {
    setLoggedInEmployee(employeeNumber);
    localStorage.setItem('loggedInEmployee', employeeNumber);
  };

  const handleLogout = () => {
    setLoggedInEmployee(null);
    localStorage.removeItem('loggedInEmployee');
  };

  if (!loggedInEmployee) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div>
      <div style={{ textAlign: 'right', padding: '10px' }}>
        <span style={{ marginRight: '15px', fontSize: '14px', color: '#666' }}>
          {loggedInEmployee === 'TEMP_NO_PIN' 
            ? 'Logowanie tymczasowe (bez PIN)' 
            : `Pracownik: ${loggedInEmployee}`
          }
        </span>
        <button onClick={handleLogout} className="logout-button">Wyloguj</button>
      </div>
      {children}
    </div>
  );
};

export default Layout; 